 export  const getCurrentUser = () => {
    const user = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_CURRENT_USER_KEY)
    );
    return user && user.userDetail ? user.userDetail : null;
  };